<template>
  <span>{{yesNo(ans)}}</span>
</template>

<script>
export default {
    props: {
        ans: {
            default: ''
        },
    },
}
</script>